import React, { useState } from 'react';
import { Alert } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';

interface ManualQuoteAlertProps {
    message?: string;
    description?: string;
    showIcon?: boolean;
    className?: string;
    type?: 'info' | 'success' | 'warning' | 'error';
    /** Customer-friendly reasons why instant pricing is not available */
    pricingFeedback?: string[] | null;
}

export const ManualQuoteAlert: React.FC<ManualQuoteAlertProps> = ({
    message = 'Submit to Get a Quote',
    description = 'Pricing for this part will be provided by one of our engineers.',
    showIcon = false,
    className = '',
    type = 'info',
    pricingFeedback,
}) => {
    const [expanded, setExpanded] = useState(false);

    const hasFeedback = pricingFeedback && pricingFeedback.length > 0;

    const descriptionContent = (
        <div>
            <span>{description}</span>
            {hasFeedback && (
                <>
                    <button
                        data-testid="manual-quote-feedback-toggle"
                        aria-expanded={expanded}
                        onClick={() => setExpanded(v => !v)}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 4,
                            marginTop: 6,
                            padding: '2px 0',
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            fontWeight: 600,
                            fontSize: 13,
                            color: 'inherit',
                            opacity: 0.85,
                            textDecoration: 'underline',
                            textUnderlineOffset: 2,
                        }}
                    >
                        {expanded ? (
                            <><UpOutlined style={{ fontSize: 10 }} /> Hide details</>
                        ) : (
                            <><DownOutlined style={{ fontSize: 10 }} /> Why is pricing not available?</>
                        )}
                    </button>
                    <div
                        data-testid="manual-quote-feedback-list"
                        data-expanded={expanded ? 'true' : 'false'}
                        style={{
                            display: 'grid',
                            gridTemplateRows: expanded ? '1fr' : '0fr',
                            transition: 'grid-template-rows 0.25s ease',
                        }}
                    >
                        <div style={{ overflow: 'hidden' }}>
                            <ul style={{ marginTop: 4, marginBottom: 0, paddingLeft: 18, listStyleType: 'disc' }}>
                                {pricingFeedback!.map((item, i) => (
                                    <li
                                        key={i}
                                        data-testid="manual-quote-feedback-item"
                                        style={{ marginBottom: 4, display: 'list-item' }}
                                    >
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </>
            )}
        </div>
    );

    return (
        <Alert
            data-testid="manual-quote-alert"
            showIcon={showIcon}
            message={message}
            description={descriptionContent}
            className={className}
            type={type}
        />
    );
};
